import React, { useState, useEffect } from "react";
import wedding from "../../../assets/images/wedding.png";
import surgery from "../../../assets/images/doctor.png";
import rental from "../../../assets/images/house.png";
import retirement from "../../../assets/images/retirement2.png";
import religious from "../../../assets/images/celebration.png";
import travel from "../../../assets/images/travel.png";
import principal from "../../../assets/images/house.png";
import business from "../../../assets/images/start_business.png";
import decorating from "../../../assets/images/remodel2.png";
import movingState from "../../../assets/images/moving.png";
import vacationHome from "../../../assets/images/house.png";
import addChild from "../../../assets/images/child.png";
import celebration from "../../../assets/images/celebration.png";
import movingCountry from "../../../assets/images/moving.png";
import education from "../../../assets/images/education.png";
import collectible from "../../../assets/images/collectibles_gem.png";
import { useHistory } from "react-router-dom";
import { MODULE_API } from "../../../apis";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
export const SelectGoal = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [allGoals, setAllGoals] = useState([]);

  const Goals = [
    {
      id: 1,
      name: "Wedding",
      image: wedding,
      link: "wedding",
    },
    {
      id: 2,
      name: "Cosmetic / Elective Surgery",
      image: surgery,
      link: "surgery",
    },
    {
      id: 3,
      name: "Rental / Investment Property",
      image: rental,
      link: "landlord",
    },
    {
      id: 4,
      name: "Retirement",
      image: retirement,
      link: "retirement",
    },
    {
      id: 5,
      name: "Religious Celebration",
      image: religious,
      link: "religious-celebration",
    },
    {
      id: 6,
      name: "Travel and Adventure",
      image: travel,
      link: "travel-adventure",
    },
    {
      id: 8,
      name: "Principal Home",
      image: principal,
      link: "principal",
    },
    {
      id: 9,
      name: "Start a Business",
      image: business,
      link: "starting-business-new",
    },
    {
      id: 10,
      name: "Remodel / Decorating",
      image: decorating,
      link: "remodel",
    },
    {
      id: 12,
      name: "Moving State",
      image: movingState,
      link: "moving-state-new",
    },
    {
      id: 13,
      name: "Vacation Home - Personal",
      image: vacationHome,
      link: "vacation_home",
    },
    {
      id: 14,
      name: "Add Child to Family",
      image: addChild,
      link: "add-child-new",
    },
    {
      id: 15,
      name: "Celebration / Party",
      image: celebration,
      link: "party",
    },
    {
      id: 16,
      name: "Moving Country",
      image: movingCountry,
      link: "moving-country-new",
    },
    {
      id: 17,
      name: "Private Education",
      image: education,
      link: "private-education-new",
    },
    {
      id: 18,
      name: "Buy Luxury / Collectible",
      image: collectible,
      link: "luxury",
    },
  ];
  const getAllGoalsList = async () => {
    try {
      setLoading(true);
      let data = await MODULE_API.insuraceAllocation("Goals");
      if (data && data.goals) {
        const sortedGoals = data.goals.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setAllGoals(sortedGoals);
        // setAllGoals(data.goals)
      }
      setLoading(false);
    } catch (error) {
      console.log("e ", error);
      setLoading(false);
    }
  };
  function handleGoalSelect(title) {
    history.push(`/goals_add/attributes/${title}`);
  }
  useEffect(() => {
    getAllGoalsList();
  }, []);
  return (
    <div>
      <h2
        className="text-center font-weight-bold mb-4"
        style={{ fontFamily: "Poppins", marginTop: "1rem" }}
      >
        Select A Goal To Create
      </h2>
      <div className="selelctmain">
        <h3 className="selectHeading">Goals</h3>
        <div className="selectmain" style={{ justifyContent: "flex-start" }}>
          {allGoals &&
            allGoals.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  handleGoalSelect(item.name);
                }}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
